import { disableBodyScroll, enableBodyScroll, createOverlayNode } from '../utils';

import '@sitebase/ui-kit/styles.css';
import '../../css/modal.css';

export default function accountActionModal({
  url,
  onClose = () => {},
  outfit = '',
  closeEventListenerType,
  closeEventListenerElement = window,
}) {
  disableBodyScroll();
  createOverlayNode();
  const domNode = document.getElementById('cp-action-overlay');

  const modalTpl = `
    <div class="cp-action-overlay__content ${
      outfit === 'full-width'
        ? 'cp-action-overlay__content--height-550 cp-action-overlay__content--full-width'
        : 'cp-action-overlay__content--with-border cp-action-overlay__content--height-498'
    }">
        <iframe class="cp-action-overlay__iframe" src="${url}" />
    </div>`;
  domNode.innerHTML = modalTpl;

  if (closeEventListenerElement instanceof HTMLElement) {
    const content = document.querySelector('.cp-action-overlay__content');
    content.appendChild(closeEventListenerElement);
  }

  const closeModal = ({ data }) => {
    if (data === 'modal_close' || closeEventListenerElement !== window) {
      enableBodyScroll();
      onClose();
      domNode.remove();
      closeEventListenerElement.removeEventListener(closeEventListenerType, closeModal);
    }
  };

  closeEventListenerElement.addEventListener(closeEventListenerType, closeModal);
}
